import { useSetPreferredCurrency } from "@/Apollo/hooks/useSetPreferredCurrency";
import { Currency } from "@/Apollo/schema";
import { useAuth } from "@/auth";
import { useDisplayCurrencyStore } from "@/features/display-currency/display-currency.store";

/**
 * Picks a display currency. Signed in, it is saved on the account there and then; a save that
 * fails leaves the pick in this browser, and the next sign-in saves it if the account has none.
 */
export const useSetDisplayCurrency = () => {
  const { isLoggedIn } = useAuth();
  const pick = useDisplayCurrencyStore(state => state.pick);
  const pickSignedIn = useDisplayCurrencyStore(state => state.pickSignedIn);
  const [setPreferredCurrency] = useSetPreferredCurrency();

  return (currency: Currency) => {
    if (!isLoggedIn) {
      pick(currency);
      return;
    }

    pickSignedIn(currency);
    setPreferredCurrency({ variables: { currency } }).catch(error =>
      console.warn("display currency: saving on the account failed", error)
    );
  };
};
